import { Action } from "@/types/workflowDefinition";

export const isScopeBranch = (branchType?: string): boolean => {
    return branchType === 'true' || branchType === 'false' || branchType === 'loop';
};

export const getActionsToAddInScope = (sourceAction: string, allActions: Record<string, Action>): Record<string, Action> | null => {
    const result: Record<string, Action> = {};
    
    // Recursively collect all actions in the chain that only have a single predecessor
    const collectChain = (currentAction: string) => {
        const followers = getActionsThatRunAfterSource(currentAction, allActions);
        for (const [actionName, action] of Object.entries(followers)) {
            // Skip if already collected (handles potential cycles)
            if (result[actionName]) continue;
            
            result[actionName] = action;
            // Recursively collect actions that follow this one
            collectChain(actionName);
        }
    };
    
    collectChain(sourceAction);
    
    // Check if any action in the chain leads to a merge point with external dependencies
    // e.g., if source -> p1 -> p2 -> p3 and p4 -> p3, return null
    // because p3 (which depends on p2) also has an external dependency (p4)
    for (const candidateName of Object.keys(result)) {
        for (const [actionName, action] of Object.entries(allActions)) {
            if (result[actionName]) continue; // skip actions in our result
            
            if (action.runAfter && action.runAfter[candidateName]) {
                // 'actionName' depends on 'candidateName' but is not in our result
                // Check if it has dependencies from outside our result (excluding sourceAction)
                const hasExternalDependency = Object.keys(action.runAfter).some(
                    dep => dep !== sourceAction && dep !== candidateName && !result[dep]
                );
                if (hasExternalDependency) {
                    // Chain has a merge point with external input - return null
                    return null;
                }
            }
        }
    }
    
    return result;
};

export const getActionsThatRunAfterSource = (sourceAction: string, allActions: Record<string, Action>): Record<string, Action> => {
    const actionsThatRunAfter: Record<string, Action> = {};
    for (const [actionName, action] of Object.entries(allActions)) {
        if (action.runAfter && action.runAfter[sourceAction] && Object.keys(action.runAfter).length === 1) {
            actionsThatRunAfter[actionName] = action;
        }
    }
    return actionsThatRunAfter;
};

